import { render } from "./UserPicker.vue?vue&type=template&id=190dee32&scoped=true&ts=true"
import script from "./UserPicker.vue?vue&type=script&lang=ts"
export * from "./UserPicker.vue?vue&type=script&lang=ts"

import "./UserPicker.vue?vue&type=style&index=0&id=190dee32&scoped=true&lang=css"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190dee32"]])

export default __exports__